import React from "react";
import strip from "strip";

export const capitalizeWord = word => word[0].toUpperCase() + word.slice(1);

export const convertToWords = input => {
  return input
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const capitalize = text =>
  text
    .split(/(\s+)/g)
    .map(capitalizeWord)
    .join("");

// spell-checker:disable
const COMMON_REPLACEMENTS = {
  amp: "&",
  copy: "©",
  nbsp: " ",
  hellip: "…",
  pound: "£",
  qoute: '"',
  gt: ">",
  lt: "<",
  "#038": "&",
  "#8220": "“",
  "#8221": "”",
  "#8211": "–",
  "#8217": "’",
  "#8230": "…",
  "#8216": "‘",
};
// spell-checker:enable

export const replaceCommonEncodings = html =>
  html.replace(
    /&(#?\w{2,5});/g,
    (_, match) => COMMON_REPLACEMENTS[match.toLowerCase()] || ""
  );

export const htmlExcerpt = (html, maxLength) => {
  const html2 = replaceCommonEncodings(html);
  let excerpt = strip(html2.replace(/<\/p>/g, "</p> ")).slice(0, maxLength);

  // Remove part word at the end
  const lastSpaceIndex = excerpt.lastIndexOf(" ");

  if (excerpt.length === maxLength && lastSpaceIndex !== -1) {
    return excerpt.slice(0, lastSpaceIndex) + "...";
  }

  return excerpt;
};

export const tidyWysiwygContent = content => {
  return content.replace(/<p(?: class="[^"]+")?><br><\/p>/g, "");
};

export const getFormattedAddress = (address, separator = "\n") => {
  const lines = [];

  if (address.address1) lines.push(address.address1);
  if (address.address2) lines.push(address.address2);
  if (address.address3) lines.push(address.address3);
  if (address.town) lines.push(address.town);
  if (address.county) lines.push(address.county);
  if (address.postcode) lines.push(address.postcode);
  if (address.country?.name) lines.push(address.country.name);

  return lines.join(separator);
};

/**
 * Return a dl -> dd from an array
 * @param {Array<{key: string|number, label: string, value: string|JSX.Element|null}>} items
 * @returns {JSX.Element}
 */
export const renderDescriptionList = (items = []) => {
  return (
    <dl className={"mb-12"}>
      {items.map(({ key, label, value }) => (
        <dd key={key} className={"flex w-full mb-2"}>
          <span className={"font-bold w-1/3 block"}>{label}:</span>
          <span className="w-2/3">{value || "Not provided"}</span>
        </dd>
      ))}
    </dl>
  );
};
